// A completion is valid only for the current operation in its mounted owner.
export class LatestOperation {
  private revision = 0;
  private active = true;
  start() {
    const revision = ++this.revision;
    return () => this.active && this.revision === revision;
  }
  cancel() {this.revision++;}
  dispose() {this.active = false; this.cancel();}
  activate() {this.active = true;}
}
